import { FC } from "react";

export const ButtonBadge: FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="absolute right-0 top-0 flex items-center justify-center text-[8px]/[1] font-semibold">
      {children}
    </div>
  );
};
